export default Object.freeze({
  AllowList: 1,
  DenyList: 2,
});
